import { render, staticRenderFns } from "./EntradaDetail.vue?vue&type=template&id=ee0c74ea&scoped=true"
import script from "./EntradaDetail.vue?vue&type=script&lang=js"
export * from "./EntradaDetail.vue?vue&type=script&lang=js"
import style0 from "./EntradaDetail.vue?vue&type=style&index=0&id=ee0c74ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0c74ea",
  null
  
)

export default component.exports